import { render, staticRenderFns } from "./Alerter.vue?vue&type=template&id=0fac8ee5&"
import script from "./Alerter.vue?vue&type=script&lang=ts&"
export * from "./Alerter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports